<template>
    <div class="comment-replies__tabs">
        <div class="tabs tabs--comments">
            <TabsItem v-for="tab in tabs"
                      :key="tab.order"
                      :tab="tab"/>
        </div>
    </div>
</template>

<script>
    import TabsItem from "VueApps/comments/components/tabs/TabsItem.vue";
    import {ORDER_FIRST, ORDER_NEW, ORDER_POPULAR} from "VueApps/comments/services/orderTypes";

    export default {
        name: "Tabs",
        components: {
            TabsItem,
        },
        computed: {
            tabs: function () {
                return [
                    {
                        order: ORDER_POPULAR,
                        title: "Популярные"
                    },
                    {
                        order: ORDER_NEW,
                        title: "Новые"
                    },
                    {
                        order: ORDER_FIRST,
                        title: "Первые"
                    },
                ]
            }
        },
    }
</script>

<style scoped>

</style>
